export default {
  'development': {
    'url': 'http://localhost:3000',
    'pdf': 'https://minds.b.sakurastorage.jp/'
  },
  'production': {
    'url': 'https://api.neo.dev.somasoma.co.jp',
    'pdf': '/files/'
  },

  LIMIT: 100
}



// WEBPACK FOOTER //
// ./src/settings/config.js